import { render, staticRenderFns } from "./ProfileSalaryAddEdit.vue?vue&type=template&id=ef578734"
import script from "./ProfileSalaryAddEdit.vue?vue&type=script&lang=js"
export * from "./ProfileSalaryAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports